import * as S from 'pages/Institutional/style'

const About = () => {
  return (
    <S.Page>
      <S.Container>
        <S.Hero>
          <S.Eyebrow>Sobre a RedSterna</S.Eyebrow>
          <S.Title>Viajar fica melhor quando experiências se conectam.</S.Title>
          <S.Lead>
            A RedSterna nasceu para reunir descoberta, inspiração, planejamento
            e compartilhamento de viagens em um só lugar — conectando destinos,
            roteiros e conteúdos que ajudam pessoas a organizar melhor suas
            próximas jornadas.
          </S.Lead>
        </S.Hero>

        <S.Body>
          <S.Section>
            <S.SectionTitle>
              Uma rede social feita para quem viaja
            </S.SectionTitle>
            <S.Paragraph>
              A RedSterna é uma plataforma digital de viagens. Aqui, destinos,
              roteiros e conteúdos podem ajudar uma pessoa a descobrir uma
              cidade, entender como organizar os dias de uma viagem e encontrar
              novas possibilidades para o próximo destino.
            </S.Paragraph>
            <S.Paragraph>
              Em vez de começar o planejamento do zero, o viajante pode explorar
              referências disponíveis na plataforma, adaptar ideias ao seu
              próprio estilo e construir sua jornada de forma mais prática.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>Como a experiência se conecta</S.SectionTitle>
            <S.List>
              <li>
                <strong>Descubra destinos:</strong> explore cidades, roteiros e
                conteúdos disponíveis na plataforma.
              </li>
              <li>
                <strong>Planeje:</strong> organize sua viagem por dias, cidades
                e experiências.
              </li>
              <li>
                <strong>Compartilhe:</strong> transforme uma viagem realizada em
                conteúdo útil para a comunidade.
              </li>
              <li>
                <strong>Inspire-se:</strong> encontre um roteiro interessante e
                use-o como ponto de partida para criar o seu.
              </li>
              <li>
                <strong>Conecte-se:</strong> acompanhe viajantes, avaliações,
                favoritos e novas experiências.
              </li>
            </S.List>
          </S.Section>

          <S.Section>
            <S.SectionTitle>O mapa é o ponto de encontro</S.SectionTitle>
            <S.Paragraph>
              Na RedSterna, os destinos ganham contexto por meio dos roteiros e
              conteúdos disponíveis na plataforma. O mapa conecta cidades aos
              roteiros que passam por elas e ajuda a transformar um simples
              ponto geográfico em ideias concretas de viagem.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>O que queremos construir</S.SectionTitle>
            <S.ValuesGrid>
              <S.ValueCard>
                <strong>Inspiração útil</strong>
                <span>
                  Roteiros, destinos e conteúdos organizados para ajudar cada
                  viajante a encontrar ideias e tomar decisões melhores.
                </span>
              </S.ValueCard>
              <S.ValueCard>
                <strong>Planejamento simples</strong>
                <span>
                  Menos planilhas soltas e mais contexto para transformar ideias
                  em um roteiro organizado.
                </span>
              </S.ValueCard>
              <S.ValueCard>
                <strong>Comunidade útil</strong>
                <span>
                  Um ambiente em que compartilhar uma experiência ajuda o
                  próximo viajante a tomar decisões melhores.
                </span>
              </S.ValueCard>
            </S.ValuesGrid>
          </S.Section>

          <S.Section>
            <S.SectionTitle>Uma plataforma em evolução</S.SectionTitle>
            <S.Paragraph>
              A RedSterna continua evoluindo com novas formas de descobrir,
              organizar e compartilhar viagens. Nosso objetivo é construir uma
              plataforma em que cada novo roteiro, conteúdo e contribuição da
              comunidade aumente o valor disponível para todos.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>Fale com a gente</S.SectionTitle>
            <S.Paragraph>
              Sugestões, dúvidas ou ideias são bem-vindas. Entre em contato pelo
              e-mail{' '}
              <a href="mailto:contato@redsterna.com.br">
                contato@redsterna.com.br
              </a>
              .
            </S.Paragraph>
          </S.Section>
        </S.Body>
      </S.Container>
    </S.Page>
  )
}

export default About
